import { Provider } from '@angular/core';
import { UserFacade } from '../user-facade/user.facade';

export function provideUserDomain(): Provider[] {
  return [UserFacade];
}
